import { MenuItem, MenuList, Stack, Typography } from '@rossum/ui/material';
import { useIntl } from '../ComponentsContext';
import { boldText } from './boldText';
import { MenuItemContentAnnotationVar } from './MenuItemContentAnnotationVar';
import { menuListSharedProps } from './shared';
import { SuggesterPopoverMode, VariableCompletion } from './types';

export const MenuListAnnotationVars = ({
  annotationVariables,
  setFirstRef,
  onInsert,
  search,
  mode = 'formula',
}: {
  annotationVariables: VariableCompletion[];
  setFirstRef: React.MutableRefObject<HTMLLIElement | null>;
  onInsert: (value: string) => void;
  search: string;
  mode?: SuggesterPopoverMode;
}) => {
  const intl = useIntl();

  return annotationVariables.length ? (
    <MenuList {...menuListSharedProps}>
      {annotationVariables.map((annotationVariable, index) => (
        <MenuItem
          key={annotationVariable.value}
          ref={index === 0 ? setFirstRef : undefined}
          onClick={() =>
            onInsert(
              mode === 'formula'
                ? annotationVariable.value
                : `{${annotationVariable.value}}`
            )
          }
        >
          <MenuItemContentAnnotationVar
            search={search}
            annotationVariable={annotationVariable}
            mode={mode}
          />
        </MenuItem>
      ))}
    </MenuList>
  ) : (
    <Stack alignItems="center" p={2}>
      <Typography variant="body1" textAlign="center" color="text.primary">
        {intl.formatMessage({
          id: 'features.formulas.suggester.menuListAnnotationVars.noResults.title',
        })}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {intl.formatMessage(
          {
            id: 'features.formulas.suggester.menuListAnnotationVars.noResults.description',
          },
          {
            bold: boldText,
            search,
          }
        )}
      </Typography>
    </Stack>
  );
};
